import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import type { WorkItem } from '../api/workItems';

export function isMergeAttachEligible(item: WorkItem | null | undefined): boolean {
    if (!item?.merge_suggestion?.target_id) return false;
    if (item.attention_reason === 'quarantine_suspicious') return false;
    if (item.suspicious_classification) return false;
    const state = (item.state || '').toUpperCase();
    if (state && state !== 'TRIAGE' && state !== 'ACTIVE') return false;
    return true;
}

export interface WorkItemMergeAttachStripProps {
    item: WorkItem;
    saving: boolean;
    onAttach: () => void;
}

const WorkItemMergeAttachStrip: React.FC<WorkItemMergeAttachStripProps> = ({
    item,
    saving,
    onAttach,
}) => {
    const targetTitle = item.merge_suggestion?.title || 'related item';

    return (
        <Box
            data-testid="WB_DRAWER_MERGE_ATTACH_STRIP"
            sx={{
                px: { xs: 2, sm: 3 },
                py: 1.25,
                borderBottom: '1px solid var(--color-border)',
                bgcolor: 'var(--color-bg-secondary)',
            }}
        >
            <Typography
                variant="caption"
                sx={{
                    display: 'block',
                    fontWeight: 700,
                    color: 'var(--color-text-secondary)',
                    mb: 0.75,
                }}
            >
                Part of {targetTitle}?
            </Typography>
            <Button
                size="small"
                variant="outlined"
                disabled={saving}
                onClick={onAttach}
                data-testid="WB_DRAWER_MERGE_ATTACH"
                sx={{
                    textTransform: 'none',
                    fontWeight: 700,
                    fontSize: '0.78rem',
                    minHeight: 36,
                    px: 1.25,
                }}
            >
                Attach
            </Button>
        </Box>
    );
};

export default WorkItemMergeAttachStrip;
